// Site-wide conversion settings. Edit these values as the offer changes.
export const SITE_CONFIG = {
  // Scarcity block
  monthlyOnboardingCap: 4,
  spotsLeft: 2,
  month: "October",

  // Step 3 of the audit form: paste your GoHighLevel calendar embed URL here.
  calendarUrl: "https://api.leadconnectorhq.com/widget/bookings/consultation-with-jumi",

  // Proof section: paste a Loom or YouTube embed URL and a poster image URL.
  founderVideoUrl: "https://drive.google.com/file/d/1tmA4WOyzZ5Vcjlt4PAFbdKtbhyxqgxtv/preview",
  founderVideoPoster: "",
};
